import { $gettext } from '@/config/gettext'

const primary = [
  // {
  //   label: $gettext('Packages'),
  //   routeName: 'Private/Package'
  // },
  // {
  //   label: $gettext('Tours'),
  //   routeName: 'Private/Tour'
  // },
  // {
  //   label: $gettext('Hotel'),
  //   routeName: 'Private/Hotel'
  // },
  {
    label: $gettext('Bookings'),
    routeName: 'Private/Bookings'
  },
  {
    label: $gettext('Account'),
    routeName: 'Private/Account'
  }
]

const secondary = [
  {
    label: $gettext('logout'),
    routeName: 'Private/Logout',
    icon: 'power'
  }
]

export {
  primary,
  secondary
}
